<button type="button" class="profile-menu-trigger" [class.open]="isOpen" (click)="toggle()" aria-label="Open user menu">
  <nz-avatar class="profile-menu-avatar" [nzSize]="34" [nzSrc]="pictureUrl" [nzText]="initial"></nz-avatar>
  <span class="profile-menu-caret"><app-account-icon name="chevron" [size]="10"></app-account-icon></span>
</button>

<ng-container *ngIf="isOpen">
  <div class="profile-menu-backdrop" (click)="close()"></div>
  <div class="profile-menu-panel" role="menu">
    <div class="profile-menu-header">
      <nz-avatar class="profile-menu-avatar small" [nzSize]="48" [nzSrc]="pictureUrl" [nzText]="initial"></nz-avatar>
      <div class="profile-menu-identity">
        <p class="profile-menu-name">{{ displayName }}</p>
        <p class="profile-menu-email">{{ displayEmail }}</p>
      </div>
    </div>
    <ul class="profile-menu-items">
      <li *ngFor="let item of items" [class.hidden]="!item._uiVisible">
        <a role="menuitem" (click)="activate(item)">
          <span class="profile-menu-item-icon"><app-account-icon [name]="item.icon" [size]="20"></app-account-icon></span>
          <span class="profile-menu-item-text">
            <span class="profile-menu-item-label">{{ item.label }}</span>
            <span class="profile-menu-item-hint">{{ item.hint }}</span>
          </span>
          <app-account-icon name="chevron" [size]="16"></app-account-icon>
        </a>
      </li>
      <li>
        <a role="menuitem" class="sign-out" (click)="onSignOut()">
          <span class="profile-menu-item-icon"><app-account-icon name="logout" [size]="20"></app-account-icon></span>
          <span class="profile-menu-item-text">
            <span class="profile-menu-item-label">Sign out</span>
          </span>
        </a>
      </li>
    </ul>
    <div class="profile-menu-footer">
      <a (click)="goTo('user-profile/terms')">Terms</a> ·
      <a (click)="goTo('user-profile/terms')">Privacy</a> ·
      <a (click)="goTo('user-profile/terms')">Cookies</a>
    </div>
  </div>
</ng-container>
